export default [
  {
    name: 'General',
    id: '1001',
    children: [
      {
        name: 'About MariBank',
        parentId: '1001',
        id: '10011',
        articles: ['001', '002', '145', '096'],
      },
      {
        name: 'Profile & Settings',
        parentId: '1001',
        id: '10012',
        articles: ['005', '045', '050', '066', '067', '137', '043', '003'],
      },
    ],
  },
  {
    name: 'Mari Savings Account',
    id: '2001',
    children: [
      {
        name: 'Account Application',
        parentId: '2001',
        id: '20011',
        articles: [
          '075',
          '081',
          '085',
          '087',
          '089',
          '086',
          '076',
          '078',
          '090',
          '148',
        ],
      },
      {
        name: 'Account Features',
        parentId: '2001',
        id: '20012',
        articles: ['037', '038', '049', '095', '101', '102', '105', '035'],
      },
      {
        name: 'e-Statement',
        parentId: '2001',
        id: '20013',
        articles: ['091', '092', '094'],
      },
      {
        name: 'Interest Rates',
        parentId: '2001',
        id: '20014',
        articles: ['107', '103', '104'],
      },
      {
        name: 'Account Fees',
        parentId: '2001',
        id: '20015',
        articles: ['022'],
      },
    ],
  },
  {
    name: 'Mari Business Account',
    id: '3001',
    children: [
      {
        name: 'Account Application',
        parentId: '3001',
        id: '30011',
        articles: [
          '501',
          '503',
          '505',
          '559',
          '507',
          '504',
          '502',
          '560',
          '149',
        ],
      },
      {
        name: 'Account Features',
        parentId: '3001',
        id: '30012',
        articles: [
          '500',
          '521',
          '513',
          '511',
          '520',
          '522',
          '552',
          '555',
          '509',
        ],
      },
      {
        name: 'e-Statement',
        parentId: '3001',
        id: '30013',
        articles: ['517', '518', '519'],
      },
      {
        name: 'Interest Rates',
        parentId: '3001',
        id: '30014',
        articles: ['516', '514', '515'],
      },
      {
        name: 'Account Fees',
        parentId: '3001',
        id: '30015',
        articles: ['557', '510'],
      },
    ],
  },
  {
    name: 'Payment & Transfer',
    id: '4001',
    children: [
      {
        name: 'Fund Transfer',
        parentId: '4001',
        id: '40011',
        articles: [
          '006',
          '025',
          '146',
          '015',
          '016',
          '017',
          '026',
          '027',
          '029',
          '030',
          '031',
          '023',
          '098',
        ],
      },
      {
        name: 'Transaction History & Status',
        parentId: '4001',
        id: '40012',
        articles: ['008', '011', '009', '010'],
      },
      {
        name: 'Failed / Wrong Transfer',
        parentId: '4001',
        id: '40013',
        articles: ['018', '012'],
      },
      {
        name: 'Transaction Limit',
        parentId: '4001',
        id: '40014',
        articles: ['019', '020'],
      },
      {
        name: 'Scan & Pay',
        parentId: '4001',
        id: '40015',
        articles: ['109', '110', '113', '147'],
      },
    ],
  },
  {
    name: 'Security',
    id: '5001',
    children: [
      {
        name: 'Login & Authentication',
        parentId: '5001',
        id: '50011',
        articles: [
          '039',
          '040',
          '041',
          '042',
          '046',
          '058',
          '060',
          '061',
          '062',
          '063',
          '143',
          '082',
          '084',
          '079',
          '077',
          '100',
        ],
      },
      {
        name: 'Fraud Prevention & Security',
        parentId: '5001',
        id: '50012',
        articles: ['071', '072', '073', '139', '140', '099'],
      },
      {
        name: 'Personal Data Protection',
        parentId: '5001',
        id: '50013',
        articles: [
          '116',
          '117',
          '118',
          '119',
          '121',
          '122',
          '123',
          '124',
          '125',
          '127',
          '128',
          '129',
        ],
      },
    ],
  },
];
